import React from 'react';
import ProductCfgUIElement from '@/UiBuilder/elements/ProductCfgUIElement/ProductCfgUIElement';

import { CfgUIElementState } from '@/stores/CfgUIElementState';
import { ICompositeProductApi } from '@canvas-logic/clp-sdk';
import { attributeLookupBehaviour } from '@/ui-kit/domain/lookup/behaviours';
import { IUICfgComponentContainerElementOptions, IUICfgProduct } from '@canvas-logic/clp-api-types';
import { ProductLookup } from '@/ui-kit/domain/lookup/ProductLookup';
import { ComponentKey } from '@canvas-logic/clp-domain';

let id = 0;

export class ProductCfgUIElementState extends CfgUIElementState {
  public id = 'product-view-state-' + ++id;
  public readonly lookup: ProductLookup;
  public visible = true;
  public readonly componentKey: ComponentKey;
  protected viewElement: IUICfgProduct;

  constructor(
    public readonly api: ICompositeProductApi,
    public readonly element: IUICfgProduct,
    public readonly componentSettings: IUICfgComponentContainerElementOptions,
  ) {
    super();
    this.viewElement = element as IUICfgProduct;
    const source = this.viewElement.source;
    this.componentKey = source.componentKey;
    this.visible = this.api.isAvailable(this.componentKey);

    const lookup = new ProductLookup(this.api, this.componentKey);
    this.lookup = lookup;

    attributeLookupBehaviour(lookup, this);
  }

  update() {
    this.lookup.updateValues();
  }

  render(): React.ReactElement {
    return (
      <ProductCfgUIElement
        viewElement={this.viewElement}
        lookup={this.lookup}
        key={this.viewElement.id}
        componentSettings={this.componentSettings}
      />
    );
  }
}
